// Exported as a regular module so we can use it in a Vue plugin and within Vuex if needed
import axios from 'axios';

const api = axios.create({
    baseURL: '/api/v1/',
    headers: {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        'X-Requested-With': 'XMLHttpRequest',
    },
});

export default api;
